/**
 * Store state for wordpress/settings module
 */
import AppAPI from '@/api'

export const initialState = {...AppAPI.settingsDefault}

const state = {...initialState}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/settings/state.js